import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { Router } from '@angular/router';
import { Workplace } from '@qaroni-app/workplace/types/workplace';

@Component({
  selector: 'qaroni-workplace-widget-item',
  templateUrl: './workplace-widget-item.component.html',
  styleUrl: './workplace-widget-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WorkplaceWidgetItemComponent {
  readonly workplace = input<Workplace | null>(null);
  readonly first = input<boolean>(false);

  private router = inject(Router);

  public goToWorkplaceDetails(): void {
    if (this.workplace()?.companyId && this.workplace()?.workplaceId) {
      this.router.navigate([
        `/companies/${this.workplace()?.companyId}/workplaces/${this.workplace()?.workplaceId}/details`,
      ]);
    }
  }

  public goToWorkplaceUpdate(): void {
    if (this.workplace()?.companyId && this.workplace()?.workplaceId) {
      this.router.navigate([
        `/companies/${this.workplace()?.companyId}/workplaces/${this.workplace()?.workplaceId}/update`,
      ]);
    }
  }
}
